const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import SpriteFrameHolder from "../../ui/spriteFrameHolder";

@ccclass
export default class DialogReceiveItem extends cc.Component {
    @property(cc.Label)
    labelNum: cc.Label = null

    @property(cc.Sprite)
    iconSprite: cc.Sprite = null

    @property(cc.Node)
    nodeParent: cc.Node = null


    protected nodeDragonBones: cc.Node = null

    setData(spriteFrame: cc.SpriteFrame, num: number, scale?: number){
        this.labelNum.string = '+' + GameUtil.currencyFormat(num)
        this.iconSprite.spriteFrame = spriteFrame
        this.iconSprite.node.scale = scale || 1
        this.iconSprite.node.active = true
        this.nodeParent.active = false
    }

    setDragonBones(node: cc.Node, num: number, scale?: number){
        this.labelNum.string = '+' + GameUtil.currencyFormat(num)

        node.parent = this.nodeParent
        node.scale = scale || 1
        node.position = cc.Vec3.ZERO
        node.active = true

        this.iconSprite.node.active = false
        this.nodeParent.active = true
    }

    reset(){
        this.nodeParent.destroyAllChildren()
        this.nodeParent.active = false
        this.iconSprite.node.active = false
    }
}